import { render, staticRenderFns } from "./VerEvolucion.vue?vue&type=template&id=6f3071a2&scoped=true"
import script from "./VerEvolucion.vue?vue&type=script&lang=js"
export * from "./VerEvolucion.vue?vue&type=script&lang=js"
import style0 from "./VerEvolucion.vue?vue&type=style&index=0&id=6f3071a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3071a2",
  null
  
)

export default component.exports